"use client";

import React, { FunctionComponent } from "react";

import { ListItem } from "@mui/material";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import Link from "next/link";

import { Image } from "~/components/image/component";
import { prepareTextAttribute } from "~/helpers/prepare-text-attribute";
import { getTestAutomationProps } from "~/helpers/test-automation-props";
import { getImageSrc } from "~/utils/image/get-image-src";

import { SocialLinks } from "../../types";

import { SOCIAL_NETWORKING_LINKS_CLASSES } from "./constants";
import { SocialNetworkLinksContainer } from "./styled";

interface SocialLinksProps {
  socialLinks: SocialLinks[];
}

export const SocialNetworkLinks: FunctionComponent<SocialLinksProps> = ({
  socialLinks,
}) => {
  return (
    <SocialNetworkLinksContainer
      item
      xs={10}
      sm={6}
      md={5}
      lg={4}
      {...getTestAutomationProps("social-links-group")}
      id="social-links-group"
    >
      <List className={SOCIAL_NETWORKING_LINKS_CLASSES.list}>
        {socialLinks.map((link) => (
          <ListItem key={link?.url} {...getTestAutomationProps("social-link")}>
            <Link
              href={link?.url ?? ""}
              passHref
              className={SOCIAL_NETWORKING_LINKS_CLASSES.link}
              target="_blank"
              rel="noreferrer"
              title={link?.label ?? ""}
            >
              <Box className={SOCIAL_NETWORKING_LINKS_CLASSES.iconWrap}>
                <Image
                  className={SOCIAL_NETWORKING_LINKS_CLASSES.iconItem}
                  src={getImageSrc(link?.props?.source)}
                  alt={prepareTextAttribute(link?.props?.alt, true)}
                  title={prepareTextAttribute(link?.props?.title)}
                  width={24}
                  height={24}
                />
              </Box>
            </Link>
          </ListItem>
        ))}
      </List>
    </SocialNetworkLinksContainer>
  );
};
